<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="calificacion" titulo="Calificación / Control Escolar" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
  <div class="bloquear-azul">

  </div>
  <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon">
      <i class="icon-worldwide fa-spin"></i>
    </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; height:100%;">

      <!-- formulario -->
      <form name="form" novalidate (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">
            <a id="catalogos" (click)="ctrl.cargarCatalogo('logos64', 'logos64?carreras_planes_id='+alumnos.carrera_plan.id, 'logo64');"></a>
            <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
            <!-- Opciones  -->
            <section class="hero is-primary">
              <div class="hero-head">
                <nav class="level">
                  <!-- Left side -->
                  <div class="level-left">
                    <div class="level-item">
                      <p class="title">
                        <span *ngIf="!ctrl.cargando" class="icon is-medium">
                          <i class="icon-computer6"></i>
                        </span>
                        <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                          <i class="icon-worldwide fa-spin"></i>
                        </span>
                        <span class="icon is-medium">
                          <i class="icon-file"></i>
                        </span> Calificaciones
                      </p>
                    </div>

                  </div>

                  <!-- Right side -->
                  <div class="level-right">

                    <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                      <span class="icon fa-2x">
                        <i class="icon-back"> </i>
                      </span>
                      <span class="tooltiptext">Regresar</span>
                    </a>

                    <a class="navbar-item is-primary tooltip" (click)="cargarDatos(alumnos.id)" id='cargar_datos_actualizar' *ngIf="alumnos.id != ''">
                      <span class="icon fa-2x">
                        <i class="icon-worldwide"></i>
                      </span>
                      <span class="tooltiptext">Actualizar</span>
                    </a>

                    <button class="navbar-item  tooltip" type="button" [ngClass]="{'is-loading': cargando}" [disabled]="cargando" *ngIf="!tieneid"
                      (click)="ctrl.abrirModal('confirmarCalificacion')">
                      <span class="icon fa-2x has-text-success">
                        <i class="icon-diskette"> </i>
                      </span>
                      <span class="tooltiptext">Guardar</span>
                    </button>
                  </div>
                </nav>
              </div>
            </section>
          </div>
        </section>

        <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">
          <section class="hero is-primary">
            <div class="hero-body">
              <nav class="level ">
                <!-- Left side -->
                <div class="level-left ">
                  <div class="level-item">
                    <p class="title">
                      <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                        <i class="icon-edit-1"></i>
                      </span>
                      Buscar alumnos
                    </p>
                  </div>
                </div>
                <div class="level-right " style=" width: 78%; ">
                  <div class="level-item" style=" width: 100%; ">
                    <div class="control has-icons-left is-expanded" style=" width: 100%; ">
                      <input autofocus autocomplete="off" ngui-auto-complete [source]="observableSource.bind(this)" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false"
                        id='buscarArticulo' value-property-name="id" display-property-name="id" path-to-data="" loading-text="Cargando..."
                        no-match-found-text="No hay resultados." (valueChanged)="select_articulo_autocomplete($event)" min-chars="3"
                        class="input is-success is-medium" type="text" placeholder="Escribe el nombre del alumno, o la matrícula">
                      <span class="icon is-medium is-left">
                        <i class="icon-search3"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </section>
          <div class="is-fullwidth has-text-centered" *ngIf="cargando">
            <br>
            <span class="tag is-primary is-large ">
              <span class="icon">
                <i class="icon-worldwide fa-spin"></i>
              </span> &nbsp;
              <span>Cargando...</span>
            </span>
          </div>

          <section style="padding: .1rem !important; overflow:auto;">

            <div class="box" *ngIf="alumnos.alumnos_metadatos.nombre != ''">
              <article class="media">
                <div class="media-left">
                  <figure class="image is-64x64">
                    <img [src]="alumnos.alumnos_metadatos.foto != null ? ctrl.API_PATH+'/adjunto/alumnos/'+alumnos.alumnos_metadatos.foto : alumnos.alumnos_metadatos.avatar != null ? alumnos.alumnos_metadatos.avatar : './assets/128x128.png'"
                      alt="Image">
                  </figure>
                </div>
                <div class="media-content" style="padding: 1.2em;">
                  <div class="content">
                    <p>
                      <strong>
                        {{alumnos.alumnos_metadatos.nombre }} {{alumnos.alumnos_metadatos.apellido_paterno }} {{alumnos.alumnos_metadatos.apellido_materno }}
                      </strong>
                      <small>{{alumnos.alumnos_metadatos.email}}</small>
                      <span > Grupo: {{alumnos.grupos.clave}}</span>
                      <span > Nivel: {{alumnos.grupos.nivel}} {{alumnos.grupos.identificador}}</span>
                      <span > Beca: {{alumnos.becas ? alumnos.becas.becas.nombre : 'Sin beca'}}</span>
                      <br>
                      <strong> Carrera Plan:</strong> {{alumnos.carrera_plan.nombre}}
                      <strong> Carrera:</strong> {{alumnos.carreras.nombre}}
                      <br>
                      <strong> Modalidad:</strong> {{alumnos.modalidades.nombre}}


                      <button class="navbar-item " type="button"  style="float: right;" *ngIf="dato[0]" (click)="imprimirKardex(dato)">
                        <span class="icon fa-2x has-text-black">
                        </span>
                        <span style="font-weight: 900" [ngClass]="(dato[0][0] * 1) > carrera_plan.minimo_aprobatorio ? 'has-text-success' : 'has-text-danger'">PROMEDIO GENERAL: {{dato[0][0]}}</span>
                      </button>

                      <button class="navbar-item  tooltip" type="button" (click)="imprimirKardex(dato)" style="float: right;">
                        <span class="icon fa-2x has-text-black">
                          <i class="icon-printer"></i>
                        </span>
                        <span class="tooltiptext">Imprimir Kardex</span>
                      </button>
                    </p>

                  </div>
                </div>
              </article>
            </div>
            <div *ngFor="let item of dato | keys">
              <div *ngIf="item.key > 0">
                <div class="box" [style.background]="item.key%2 == 0 ? 'rgba(220, 220, 220, 0.28)' : '#ffffff'">
                  <article class="media">
                    <div class="media-left" style="display: table-caption;">
                      <p style="font-size:1.5em">
                        <strong>{{periodos_escolares.tipos_periodos.nombre_para_mostrar}}: {{item.key}}</strong>
                      </p>
                      <p style="font-size:1.3em" [ngClass]="(dato[0][item.key] * 1) > carrera_modulo_nivel[item.key].minimo_aprobatorio ? 'has-text-success' : 'has-text-danger' ">
                        <span style="font-weight: 900">PROMEDIO:</span> {{dato[0][item.key]}}
                      </p>
                      <p>
                        DOCENTE: <small>{{docentes[item.key].nombre}}</small>
                      </p>
                      <p>
                        <button class="navbar-item  tooltip" type="button" (click)="imprimirParcial(item.value)" style="float: left;">
                          <span class="icon fa-2x has-text-link">
                            <i class="icon-printer"></i>
                          </span>
                          <span class="tooltiptext">Imprimir Boleta Parcial</span>
                        </button>

                        <button class="navbar-item  tooltip" type="button" (click)="imprimirBoletaPromedio(item.value)" style="float: right;">
                          <span class="icon fa-2x has-text-success">
                            <i class="icon-printer"></i>
                          </span>
                          <span class="tooltiptext">Imprimir Boleta {{periodos_escolares.tipos_periodos.nombre}}</span>
                        </button>
                      </p>
                    </div>
                    <div class="media-content">
                      <div class="card" *ngFor="let materia of item.value; let mati = index">
                        <header class="card-header" [style.background]="!materia.es_practica ? 'gainsboro' : '#84b4de'">
                          <div class="card-header-title" style="font-weight: 200; display: flow-root;">
                            <div style="float:left" *ngIf="materia.es_practica == 0"> <strong>MATERIA #{{mati + 1}}: </strong>({{materia.clave}}) {{materia.nombre}} <small *ngIf="materia.tiene_practica" class="tag">Tiene practica</small></div>
                            <div style="float:left" *ngIf="materia.es_practica == 1"> <strong>PRACTICA: </strong>{{materia.nombre}} ({{ materia.porcentaje_valor }})</div>
                            <div style="float:right" *ngIf="materia.es_practica == 0" [ngClass]="(materia.promedio * 1) > carrera_modulo_nivel[item.key].minimo_aprobatorio ? 'has-text-success' : 'has-text-danger' "> <span style="font-weight: 900">PROMEDIO: </span>{{materia.promedio}}</div>
                          </div>
                        </header>
                        <div class="card-content">
                          <div class="content">
                            <div class="tile is-ancestor" *ngIf="materia.es_practica == 0">

                              <div class="tile is-parent" *ngFor="let parcial of materia.calificaciones" >
                                <article class="tile is-child box">
                                  <div class="field">
                                    <label class="label">Parcial {{parcial.numero_parcial}}:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                      <input class="input" type="number"
                                      min="0"
                                      [max]="carrera_modulo_nivel[item.key].maximo_aprobatorio"
                                      [step]="carrera_modulo_nivel[item.key].materia_numero_decimales"
                                      [(ngModel)]="parcial.calificacion" (keyup)="validar_max($event, parcial.calificacion, carrera_modulo_nivel[item.key].maximo_aprobatorio)"
                                      [ngModelOptions]="{standalone: true}" >
                                    </div>
                                  </div>
                                </article>
                              </div>

                            </div>

                            <div class="tile is-ancestor" *ngIf="materia.es_practica == 1">

                              <div class="tile is-parent" *ngFor="let parcial of materia.calificaciones" >
                                <article class="tile is-child box">
                                  <div class="field">
                                    <label class="label">Calificación:</label>
                                    <div class="control is-expanded  has-icon has-icon-left">
                                      <input class="input" type="number"
                                      min="0"
                                      [max]="carrera_modulo_nivel[item.key].maximo_aprobatorio"
                                      [step]="carrera_modulo_nivel[item.key].materia_numero_decimales"
                                      [(ngModel)]="parcial.calificacion" (keyup)="validar_max($event, parcial.calificacion, carrera_modulo_nivel[item.key].maximo_aprobatorio)"
                                      [ngModelOptions]="{standalone: true}">
                                    </div>
                                  </div>
                                </article>
                              </div>

                            </div>
                          </div>
                        </div>

                      </div>

                    </div>
                  </article>
                </div>
              </div>
            </div>

          </section>
        </section>
      </form>
    </div>
  </div>
</div>


<div class="modal" id="confirmarCalificacion">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa fa-warning"></i> Alerta</p>
      <button class="delete" (click)="ctrl.cancelarModal('confirmarCalificacion')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <h1>¿Esta seguro de guardar los cambios?</h1>
        <p>Esta acción podra afectar boletas impresas anteriormente</p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="enviar()" [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
      <a class="button" (click)="ctrl.cancelarModal('confirmarCalificacion')">Cerrar</a>
    </footer>
  </div>
</div>
